// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3kBrk","content":"styles_content__1-BlK","row":"styles_row__12u-R","footer":"styles_footer__oa9ew","phraseLength":"styles_phraseLength__2XLCK"};